import React from 'react';
import { useNavigate } from 'react-router-dom';

function TermsOfServicePage() {
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-[900px] mx-auto px-4 md:px-8 py-12">
      <button
        onClick={() => navigate('/')}
        className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors mb-8"
      >
        <span className="material-symbols-outlined">arrow_back</span>
        <span>Back to Marketplace</span>
      </button>

      <div className="bg-surface-dark border border-white/5 rounded-xl p-8 animate-fadeIn">
        <h1 className="text-4xl font-bold text-white mb-6">Terms of Service</h1>
        <p className="text-gray-400 mb-8">Last Updated: January 2026</p>

        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p className="leading-relaxed">
              By accessing and using StreetMoneyGaming, you accept and agree to be bound by the terms and provision of this agreement.
              If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Use License</h2>
            <p className="leading-relaxed mb-4">
              Permission is granted to download and use purchased digital products for personal or commercial FiveM server use under the following conditions:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>This license is granted per server instance</li>
              <li>You may not redistribute or resell any purchased products</li>
              <li>You may not claim ownership of the original work</li>
              <li>Modifications for personal use are permitted</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Purchases and Refunds</h2>
            <p className="leading-relaxed mb-4">
              All sales are final. Due to the digital nature of our products, refunds are generally not provided unless:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>The product is fundamentally broken or not as described</li>
              <li>You can demonstrate that the product was not delivered</li>
              <li>A request is made within 48 hours of purchase with valid reasoning</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Prohibited Activities</h2>
            <p className="leading-relaxed mb-4">You agree not to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Reverse engineer, decompile, or disassemble any products</li>
              <li>Share download codes or links with unauthorized parties</li>
              <li>Use products in a way that violates any applicable laws</li>
              <li>Engage in fraudulent payment activities</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Limitation of Liability</h2>
            <p className="leading-relaxed">
              StreetMoneyGaming shall not be liable for any indirect, incidental, special, consequential, or punitive damages
              resulting from your use of or inability to use the service or products.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Changes to Terms</h2>
            <p className="leading-relaxed">
              We reserve the right to modify these terms at any time. Continued use of the service after changes
              constitutes acceptance of the modified terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Contact</h2>
            <p className="leading-relaxed">
              For questions about these Terms of Service, please contact us through our Discord server.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsOfServicePage;
